// extracted by mini-css-extract-plugin
export default {"bedsWrapper":"styles_bedsWrapper__cEPc1","selectWrapper":"styles_selectWrapper__QXMiA","option":"styles_option__Y960Y","dropdownLabel":"styles_dropdownLabel__R5QYj"};